/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { message } from 'antd'
import {
  GETCLUBTABLE,
  GETCLUBTIMEPRICE,
  GETCLUBTABLETYPE,
  GETTOTALTYPE,
  GETCLUBTABLEINFO,
  GETWALLETTYPE,
  GETQROCODE,
  GETALLPACKAGE,
  GETALLOWPACKAGE,
  IS_EXIST_RELATION_INFO,
  GETEDITRECORD,
} from './constants'
import { OK } from '../CheckOutAdvManage/constants'
import moment from 'moment'

export const getClubTable = (payload) => {
  return {
    type: GETCLUBTABLE,
    payload,
  }
}

export const getClubTimePrice = (payload) => {
  return {
    type: GETCLUBTIMEPRICE,
    payload,
  }
}

export const getClubTableType = (payload) => {
  return {
    type: GETCLUBTABLETYPE,
    payload,
  }
}

export const getTotalType = (payload) => {
  return {
    type: GETTOTALTYPE,
    payload,
  }
}

export const getClubTableInfo = (payload) => {
  return {
    type: GETCLUBTABLEINFO,
    payload,
  }
}

export const getWalletType = (payload) => {
  return {
    type: GETWALLETTYPE,
    payload,
  }
}

export const getQrcode = (payload) => {
  return {
    type: GETQROCODE,
    payload,
  }
}

export const setAllPackage = (payload) => {
  return {
    type: GETALLPACKAGE,
    payload,
  }
}

export const setCurrentAllowPackage = (payload) => {
  return {
    type: GETALLOWPACKAGE,
    payload,
  }
}

export const setEditRecord = (payload) => {
  return {
    type: GETEDITRECORD,
    payload,
  }
}

//桌台列表
export function fetchClubTable() {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/TableList/club_id/${club}`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubTable(data.list))
      return data
    })
  }
}

//桌台详情
export function fetchClubTableInfo(body) {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/TableInfo`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      dispatch(getClubTableInfo(data.info))
    })
  }
}

//删除桌台
export function fetchDeleteTable(table_id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/DelTable/table_id/${table_id}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubTable())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//修改桌台
export function fetchUpdateTable(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/updateTable`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubTable())
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//分时段设置
export function fetchAddTimeInterval(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/AddTimeInterval`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchCheckInterval(body.selectedId[0])) //table_id
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//分时段价格
export function fetchCheckInterval(table_id) {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/CheckInterval`
    return postData(
      endpoint,
      'POST',
      JSON.stringify({
        club_id: club,
        table_id: table_id,
      })
    ).then((data) => {
      dispatch(getClubTimePrice(data.list))
    })
  }
}

//删除分时段
export function fetchDeleteInterval(time_id, table_id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/DeleteInterval`
    return postData(
      endpoint,
      'POST',
      JSON.stringify({
        id: time_id,
      })
    ).then((data) => {
      if (data.status === true) {
        dispatch(fetchCheckInterval(table_id))
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//修改分时段价格
export function fetchUpdateInterval(time_id, new_price, table_id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/UpdateInterval`
    return postData(
      endpoint,
      'POST',
      JSON.stringify({
        id: time_id,
        price: new_price,
      })
    ).then((data) => {
      if (data.status === true) {
        dispatch(fetchCheckInterval(table_id))
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//删除所有分时段
export function fetchClearInterval() {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/ClearInterval/club_id/${club}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

export function fetchClubTableType() {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/AddTable/club_id/${club}`
    return fetchData(endpoint).then((data) => {
      dispatch(getClubTableType(data.list))
    })
  }
}

//增加桌台
export function fetchClubAddTable(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/AddTable`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubTable())
        message.success(data.detail)
        callback()
      } else {
        message.error(data.detail)
      }
    })
  }
}

//总分类
export function fetchTotalType() {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/AddFirmType`
    return fetchData(endpoint).then((data) => {
      dispatch(getTotalType(data.list))
    })
  }
}

//获取俱乐部钱包
export function fetchClassifyWallet(type_id) {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/SetClassifyWallet/club_id/${club}/type_id/${type_id}`
    return fetchData(endpoint).then((data) => {
      dispatch(getWalletType(data))
    })
  }
}

//设置钱包在这张台是否可用
export function fetchSetClassifyWallet(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/SetClassifyWallet`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}

//生成二维码
export function fetchBuildQrcode(table_id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/BuildQrcode/table_id/${table_id}`
    return fetchData(endpoint).then((data) => {
      dispatch(getQrcode(data))
    })
  }
}

//批量设置低消
export function fetchLowConsumption(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/LowConsumption`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        message.info(data.detail)
        dispatch(fetchClubTable())
        callback()
      } else {
        message.error(data.detail)
      }
    })
  }
}

//重置低消
export function fetchClearConsumption() {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/ClearConsumption/club_id/${club}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        message.success(data.detail)
        dispatch(fetchClubTable())
      } else {
        message.error(data.detail)
      }
    })
  }
}

//获取所有套餐
export function fetchAllPackage() {
  return (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/getPrepaid?club_id=${club}`
    return fetchData(endpoint).then((res) => {
      if (res && res.status === OK) {
        dispatch(setAllPackage(res.data))
      } else {
        message.error(res ? res.detail : '服务暂不可用')
      }
    })
  }
}

//获取当前点击详细获取到的已启用套餐
export function fetchCurrentPackage(tableId) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/getPrepaidByTable?table_id=${tableId}`
    return fetchData(endpoint).then((res) => {
      if (res && res.status === OK) {
        const data = res.data
        if (data && Array.isArray(data) && data.length > 0) {
          dispatch(setCurrentAllowPackage(res.data[0].prepaids))
        } else {
          dispatch(setCurrentAllowPackage([]))
        }
      } else {
        message.error(res ? res.detail : '服务暂不可用')
      }
    })
  }
}

// 球台s设置套餐s
export function fetchBindPackage(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/bindPrepaidTable`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      if (res && res.status === OK) {
        message.success('操作成功')
        callback(true)
      } else {
        message.error(res ? res.detail : '服务暂不可用')
        callback(false)
      }
    })
  }
}

// 套餐设置球台s
export function fetchPackageToTables(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/bindTablePrepaid`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      if (res && res.status === OK) {
        message.success('操作成功')
        callback(true)
      } else {
        message.error(res ? res.detail : '服务暂不可用')
        callback(false)
      }
    })
  }
}

export function fetchAddPackage(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/putPrepaid`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      if (res && res.status === OK) {
        message.success('新增成功')
        callback(true, res)
      } else {
        callback(false, res)
      }
    })
  }
}

export function fetchCurrentTableByPackage(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/getTableByPrepaid`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      if (res && res.status === OK) {
        message.success('请求成功')
        callback(true, res)
      } else {
        callback(false, res)
      }
    })
  }
}
export function fetchEditPackage(body, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/ServiceApi/editPrepaid`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      if (res && res.status === OK) {
        message.success('修改成功')
        callback && callback(true, res)
      } else if (res && +res.status === IS_EXIST_RELATION_INFO) {
        message.error('请先关闭该套餐的所有已启用开关，保存设置后再删除')
        callback && callback(false, res)
      } else {
        message.error(res ? res.detail : '请求失败')
        callback && callback(false, res)
      }
    })
  }
}

// 一键下载二维码
export function downloadTableQrCodes() {
  return async (dispatch, getState) => {
    const club = sessionStorage.getItem('club_id')
    const endpoint = `${API_DOMAIN}/Home/QrApi/tableQrImages?clubId=${club}`
    const res = await fetchData(endpoint, true)
    if (res) {
      res.blob().then((blob) => {
        let blobUrl = window.URL.createObjectURL(blob)
        let aElement = document.createElement('a')
        document.body.appendChild(aElement)
        aElement.style.display = 'none'
        aElement.href = blobUrl
        let fileName = new Date().toLocaleString() + '.zip'
        aElement.download = fileName
        aElement.click()
        window.URL.revokeObjectURL(blobUrl)
        document.body.removeChild(aElement)
      })
    }
  }
}

// 单个球台码下载
export function downloadSingleTableQrcode(tableName, tableId) {
  return async (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/QrApi/tableQrImage?tableId=${tableId}`
    const res = await fetchData(endpoint, true)
    if (res) {
      res.blob().then((blob) => {
        let blobUrl = window.URL.createObjectURL(blob)
        let aElement = document.createElement('a')
        document.body.appendChild(aElement)
        aElement.style.display = 'none'
        aElement.href = blobUrl
        let fileName = tableName + '.png'
        aElement.download = fileName
        aElement.click()
        window.URL.revokeObjectURL(blobUrl)
        document.body.removeChild(aElement)
      })
    }
  }
}

// 返回限时购买文本 00:00-00:00，每周一、二、三...
export function timeLimitText(record) {
  return (dispatch, getState) => {
    if (record && !record.isPurchaseLimitEnabled) {
      return '不限时'
    }
    if (record.purchaseWeekday == 0) {
      return ''
    }
    /*
      十进制转二进制再转成数组形式再反转数组如： 127 -> 1111111 -> [1,1,1,1,1,1,1,1]
                                              127 -> 此处是7~1 -> 变成1~7
    */
    const pwd = record.purchaseWeekday.toString(2).split('').reverse()
    const sd = new Date()
    const ed = new Date()
    sd.setHours(
      record.purchaseStartTime.split(':')[0],
      record.purchaseStartTime.split(':')[1]
    )
    ed.setHours(
      record.purchaseEndTime.split(':')[0],
      record.purchaseEndTime.split(':')[1]
    )
    let showText = `${moment(sd).format('HH:mm')}-${moment(ed)
      .format('HH:mm')
      .substr(0, 5)}，每周`
    for (let index = 0; index < pwd.length; index++) {
      const item = pwd[index]
      if (item > 0) {
        showText = `${showText}${exectWeekText(index)}、`
      }
    }
    return showText.substr(0, showText.length - 1)
  }
}

function exectWeekText(index) {
  let text = ''
  switch (index) {
    case 0:
      text = '一'
      break
    case 1:
      text = '二'
      break
    case 2:
      text = '三'
      break
    case 3:
      text = '四'
      break
    case 4:
      text = '五'
      break
    case 5:
      text = '六'
      break
    case 6:
      text = '日'
      break
    default:
      break
  }
  return text
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/action.js